<template>
  <div>
    <p style="font-weight: bold; color: #df0303; font-size: 1.3rem">
      ATTENTION: Chacune des trois (3) tâches doit être soumise individuellement pour obtenir une
      note à l'examen.
    </p>

    <h2 class="mb-4">Information du Départ</h2>

    <v-simple-table>
      <thead>
        <tr>
          <td colspan="2" style="font-weight: bold; font-size: 1.13rem">
            Examen pratique de laboratoire - 2025
          </td>
        </tr>
        <tr v-for="field in fields" :key="field">
          <td style="width: 220px">
            {{ field.name }}
          </td>
          <td>
            <v-text-field v-model="inputs[field.inputKey]" />
          </td>
        </tr>
      </thead>
    </v-simple-table>
  </div>
</template>

<script>
import DynamicQuestionMixin from '../../mixins/dynamic-question';

export default {
  name: 'UOttawa1701ExamCover2025Fr',
  mixins: [DynamicQuestionMixin()],
  data() {
    return {
      inputs: {
        title: null,
        author: null,
        demonstrator: null,
        date: null,
      },
      fields: [
        {name: "Nom de l'étudiant: ", inputKey: 'author'},
        {name: 'Nom du TA (démonstrateur): ', inputKey: 'demonstrator'},
        {name: "Date que l'expérience a été effectueéé: ", inputKey: 'date'},
      ],
    };
  },
};
</script>

<style scoped></style>
